let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("P5iE2")).then(() => parcelRequire('4dLYc'));